import { Card, Tabs, Typography } from 'antd';
import DeptInLongTerm from '../component/dept/DeptInLongTerm';
import DeptInMonth from '../component/dept/DeptInMonth';

const { TabPane } = Tabs;
const { Title, Paragraph } = Typography;

const Dept = () => {
  return (
    <div className=" mx-auto p-4">
      <Card className="shadow-md mb-6">
        <Title level={2} className="mb-2">
          Quản Lý Nợ Khách Hàng
        </Title>
        <Paragraph className="text-gray-600 mb-4">
          Xem và quản lý thông tin nợ của khách hàng. Nợ tháng hiện tại hiển thị
          những khách hàng có các khoản thanh toán chưa được hoàn thành trong
          tháng hiện tại, trong khi nợ dài hạn hiển thị các khách hàng có khoản
          thanh toán quá hạn từ những tháng trước.
        </Paragraph>

        <Tabs defaultActiveKey="1" className="mb-0">
          <TabPane tab="Nợ Tháng Hiện Tại" key="1">
            <div className="p-4">
              <DeptInMonth />
            </div>
          </TabPane>
          <TabPane tab="Nợ Dài Hạn" key="2">
            <div className="p-4">
              <DeptInLongTerm />
            </div>
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default Dept;
